<template>
    <div>
        <h2>
            Lämna omdöme på förfrågan: <i>{{ request.Title }}</i>
        </h2>
        <transition name="fade" mode="out-in">
            <div v-if="step == 1" key="1" class="company-wrap">
                <atom-select
                    :alternatives="comapiesList"
                    :label="'Vem utförde jobbet?'"
                    :id="'company'"
                    @input="updateCompany"
                    :placeholder="'Välj ett företag'"
                ></atom-select>
            </div>

            <div v-if="step == 2" key="2" class="rating-wrap">
                <p>
                    Hur väl tycker du att
                    <strong>{{ selectedCompany() }}</strong> utförde uppdraget?
                </p>
                <rating-select
                    v-model="ratingValue"
                    @input="next()"
                ></rating-select>
            </div>

            <div v-if="step == 3" key="3">
                <p>Hur upplevde du din hantverkare?</p>
                <input-text v-model="title" :label="'Rubrik'" />
                <text-area
                    v-model="message"
                    :label="'Kommentar'"
                    :placeholder="
                        'Sammanfatta gärna din upplevelse av hantverkaren'
                    "
                />
                <input-text
                    v-model="signature"
                    :label="'Signatur'"
                    :placeholder="'Exempelvis: Ditt förnamn'"
                />

                <div class="btn-wrap">
                    <atom-button
                        :label="'Tillbaka'"
                        class="c-a-button--theme-secondary"
                        @buttonClicked="back()"
                    ></atom-button>

                    <atom-button
                        :label="'Skicka'"
                        class="c-a-button--theme-primary"
                        @buttonClicked="submit()"
                    ></atom-button>
                </div>
            </div>

            <div v-if="step == 4" key="4">
                <div
                    class="c-t-request__main"
                    v-if="!loading && !error"
                    key="content"
                >
                    <div
                        class="c-t-request__main"
                        v-if="!loading && !error"
                        key="content"
                    >
                        <div class="c-m-success-state">
                            <div class="c-m-success-state__inner">
                                <icon
                                    class="c-m-success-state__hero-icon"
                                    :icon="icon"
                                />
                                <p class="c-m-success-state__heading">Tack!</p>
                                <div class="c-m-success-state__body">
                                    Ditt omdöme har blivit registrerat.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    class="c-t-request__main"
                    v-else-if="loading && !error"
                    key="loading"
                >
                    <loader class="c-m-loader--x-large" />
                </div>
                <div class="c-t-request__main" v-else key="error-1">
                    <error-state></error-state>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import {
    SEND_RATING_FOR_REQUEST_ID,
    SET_COMPANYID,
    SET_RATING,
    SET_TITLE,
    SET_MESSAGE,
    SET_SIGNATURE,
    GET_CONTENT,
    IS_LOADING,
    GET_ERROR
} from "../../../store/store-models/rating-model";

import RatingSelect from "../atoms/AtomRatingSelect.vue";
import InputText from "../atoms/form/AtomInputText.vue";
import TextArea from "../atoms/form/AtomTextarea.vue";
import Icon from "../atoms/AtomIcon.vue";
import AtomButton from "../atoms/AtomButton.vue";
import AtomSelect from "../atoms/form/AtomSelect.vue";

import Loader from "../molecules/MoleculeLoader.vue";
import ErrorState from "../molecules/MoleculeErrorState.vue";

export default {
    components: {
        Icon,
        AtomButton,
        AtomSelect,
        RatingSelect,
        InputText,
        TextArea,
        Loader,
        ErrorState
    },
    props: {
        request: {
            default: {},
            type: Object
        },
        icon: {
            type: String,
            default: "sentiment_very_satisfied"
        }
    },
    data() {
        return {
            step: 1
        };
    },
    computed: {
        ...mapGetters({
            rating: GET_CONTENT,
            loading: IS_LOADING,
            error: GET_ERROR
        }),
        comapiesList: {
            get() {
                return this.request.Companies.map(item => {
                    return {
                        value: item.CompanyId,
                        text: item.CompanyName
                    };
                });
            }
        },
        company: {
            get() {
                return this.rating.CompanyId;
            },
            set(value) {
                this.$store.commit(SET_COMPANYID, value);
            }
        },
        ratingValue: {
            get() {
                return this.rating.Rating;
            },
            set(value) {
                this.$store.commit(SET_RATING, value);
            }
        },
        title: {
            get() {
                return this.rating.Title;
            },
            set(value) {
                this.$store.commit(SET_TITLE, value);
            }
        },
        message: {
            get() {
                return this.rating.Message;
            },
            set(value) {
                this.$store.commit(SET_MESSAGE, value);
            }
        },
        signature: {
            get() {
                return this.rating.Signature;
            },
            set(value) {
                this.$store.commit(SET_SIGNATURE, value);
            }
        }
    },
    methods: {
        ...mapActions({
            sendRating: SEND_RATING_FOR_REQUEST_ID
        }),
        updateCompany(value) {
            this.company = value;
            this.step++;
        },
        selectedCompany() {
            const cId = this.company;
            const selectedCompany = this.comapiesList.find(x => x.value == cId);

            if (!selectedCompany || !selectedCompany.text) {
                return "hantverkaren";
            }
            return selectedCompany.text;
        },
        next() {
            this.step++;
        },
        back() {
            this.step = 1;
        },
        submit() {
            this.step++;
            this.sendRating(this.request.Id);
            this.$emit("completed", true);
        }
    },
    created() {
        this.title = this.request.Title;
    }
};
</script>

<style scoped>
.company-wrap,
.rating-wrap {
    padding: 40px 0;
}

.rating-wrap {
    text-align: center;
    display: flex;
    align-items: center;
    flex-direction: column;
}

.btn-wrap {
    text-align: center;
    margin-top: 20px;
}

.fade-enter-active {
    transition: all 0.2s ease;
}
.fade-leave-active {
    transition: all 0.4s cubic-bezier(1, 0.5, 0.8, 1);
}
.fade-enter,
.fade-leave-to {
    transform: translateX(10px);
    opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/components/organisms/OrganismRatingForm.vue